<template>
  <div>
    <PhieuBaoHanhForm />
  </div>
</template>

<script>
import { Container, Draggable } from "vue-dndrop";
import PhieuBaoHanhForm from "../components/organisms/PhieuBaoHanhForm.vue";

export default {
  name: "PhieuBaoHanh",
  components: { PhieuBaoHanhForm },
  data() {
    return {};
  },

  methods: {},
};
</script>

<style style type="scss" media="print" scoped></style>
